import { Typography } from "@mui/material";
import "./DisplayWindow.scss";

function DisplayWindow({ expression, result }) {
  return (
    <div className="display-window-container">
      <div className="displayWindow">
        <Typography className="expression">{expression}</Typography>
        <Typography className="result">{result}</Typography>
      </div>
    </div>
  );
}

export default DisplayWindow;
